import React from "react";
import "./flexiaccessmodal.scss";
import { Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Link } from "react-router-dom";

const FlexiAccessModal = (props) => {
  return (
    <div className="fam-parent">
      <Row className="mb-3">
        <Col>
          <div className="fam-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="fam-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      <Row className="fam-sub-title mb-5">
        <Col>
          <div className="mb-3">
            You have selected flexi-access for some or all of your drawdown. You
            will now be asked to select the investment choice for flexi-access.
            After, you can choose your drawdown income amount.
          </div>
          <div>
            Please review your flexi-access investment choice regularly to
            ensure that it continues to meet your needs and risk appetite.
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="fam-button">
            <div className="fam-strategy-link">
              <Buttons
                name="Choose different strategy"
                className="tertiary"
                variantname="icon-sixteen-px"
                handleClick={props.handleCloseButton}
              ></Buttons>
            </div>
            <div>
              <Buttons
                name="Continue"
                className="primary"
                variantname="icon-sixteen-px"
                handleClick={() => props.handleFlexiAccessContinue(false)}
              ></Buttons>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FlexiAccessModal;
